import React from "react";
const CustomLoader = ({ className }) => {
  return (
    <div
      className={`flex justify-center items-center min-h-screen ${className}`}
    >
      <div className="w-16 h-16 border-t-4 border-blue-500 border-solid rounded-full animate-spin"></div>
    </div>
  );
};

export default CustomLoader;
